/** Evidência (resultado do KPI, ação do plano): documento, planilha ou imagem até 10 MB. */
export const EVIDENCE_MAX_BYTES = 10 * 1024 * 1024;

/** Extensões aceitas no seletor de arquivo (o servidor confere o tipo pelo conteúdo). */
export const EVIDENCE_EXTENSIONS = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  '.xlsx',
  '.xls',
  '.csv',
  '.docx',
  '.doc',
  '.txt',
] as const;
export const EVIDENCE_ACCEPT = EVIDENCE_EXTENSIONS.join(',');

/**
 * Problema do arquivo escolhido, conferido antes de enviar (null = pode enviar). `what` é o que está sendo
 * enviado, para o texto do tamanho (padrão: a evidência).
 */
export function evidenceFileProblem(
  file: { name: string; size: number },
  what: 'A evidência' | 'O arquivo' = 'A evidência',
): string | null {
  const name = file.name.toLowerCase();
  if (!EVIDENCE_EXTENSIONS.some((ext) => name.endsWith(ext))) {
    return 'Envie um documento, planilha ou imagem (PDF, Word, Excel, CSV, texto, PNG, JPG ou WebP).';
  }
  if (file.size > EVIDENCE_MAX_BYTES) return `${what} pode ter até 10 MB.`;
  if (file.size === 0) return 'O arquivo está vazio.';
  return null;
}
